import { GitCommitHorizontal } from "lucide-react";
import type { DatasetMeta, UpdateLogEntry } from "../types";

type UpdateLogProps = {
  meta: DatasetMeta | null;
  log: UpdateLogEntry[];
};

export function UpdateLog({ meta, log }: UpdateLogProps) {
  return (
    <section className="log-shell" aria-labelledby="log-title">
      <div className="section-heading">
        <div>
          <p className="eyebrow">CHANGE LOG</p>
          <h2 id="log-title">更新记录</h2>
        </div>
      </div>

      <div className="log-layout">
        <div className="source-panel">
          <h3>数据来源状态</h3>
          {meta ? (
            <dl>
              <div>
                <dt>来源</dt>
                <dd>
                  <a href={meta.source_url} target="_blank" rel="noreferrer">
                    {meta.source_title}
                  </a>
                </dd>
              </div>
              <div>
                <dt>来源日期</dt>
                <dd>{meta.source_date}</dd>
              </div>
              <div>
                <dt>生成时间</dt>
                <dd>{meta.generated_at}</dd>
              </div>
              <div>
                <dt>记录数</dt>
                <dd>{meta.record_count}</dd>
              </div>
            </dl>
          ) : (
            <p>元信息加载中。</p>
          )}
        </div>

        <ol className="log-list">
          {log.map((entry) => (
            <li key={`${entry.date}-${entry.title}`}>
              <GitCommitHorizontal size={18} />
              <div>
                <span className="log-date">{entry.date}</span>
                <h3>{entry.title}</h3>
                <p>{entry.summary}</p>
                <span className="log-operator">{entry.operator}</span>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
